import { motion, AnimatePresence } from 'framer-motion'
import React from 'react'
import { useCartState, useCartDispatch } from '@/contexts/CartContext'
import { applyCoupon, removeCoupon } from 'CartActions'
import { toast } from 'react-hot-toast'
import alerts from '@/config/alerts.json'

const CouponForm = () => {
    const [coupon, setCoupon] = React.useState('')
    const cart = useCartState()
    const cartDispatch = useCartDispatch()

    const SubmitCoupon = () => {
        if (coupon == '') {
            toast.error(alerts.coupon_empty, {
                duration: 500,
            })
            setCoupon('')
        } else {
            cartDispatch(applyCoupon(coupon))
        }
    }

    React.useEffect(() => {
        if (cart.coupon) {
            setCoupon(cart.coupon)
        }
    }, [cart])

    return (
        <div >
            <form
                onSubmit={e => {
                    e.preventDefault()
                    if (cart.coupon) {
                        cartDispatch(removeCoupon())
                        setCoupon('')
                    } else {
                        SubmitCoupon()
                    }
                }}
                className="flex justify-between items-center mt-4 p-2 border rounded-lg border-gray-200">
                <input
                    type="text"
                    placeholder="ادخل كود الخصم"
                    className="flex-1 py-1 text-sm border border-white focus:outline-none focus:ring-0 focus:border-white focus:border-0"
                    disabled={cart.coupon ? true : false}
                    value={coupon}
                    onChange={e => {
                        setCoupon(e.target.value)
                    }}
                />
                <AnimatePresence mode="wait">
                    {cart.coupon ? (
                        <motion.button
                            type="submit"
                            initial={{ opacity: 0, x: 20 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: 20 }}
                            transition={{ duration: 0.2 }}
                            className="bg-red text-white rounded-lg px-2 py-1 ">
                            الغاء
                        </motion.button>
                    ) : coupon.length > 0 && (
                        <motion.button
                            type="submit"
                            initial={{ opacity: 0, x: 20 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: 20 }}
                            transition={{ duration: 0.2 }}
                            className="bg-emerald-400 text-white rounded-lg px-2 py-1 ">
                            تفعيل
                        </motion.button>
                    )}
                </AnimatePresence>
            </form>
        </div>
    )
}

export default CouponForm 